export const WELLNESS = "wellness"
export const HEALTH_CONFIRM = "healthconfirm"
export const VERIZON = "verizon"
export const BLUESTONE = "bluestone"
export const ALL_IMPLEMENTATIONS = [WELLNESS, HEALTH_CONFIRM, VERIZON, BLUESTONE] as const

export type Implementation = typeof ALL_IMPLEMENTATIONS[number]